import { Action } from '@ngrx/store';
import { RoleModel } from '../../../security/models/RoleModel';

export const REMOVE_ROLE_FROM_USER_SUCCESS = '[Customer] User Remove Role Success';

export class RemoveRoleFromUserSuccessAction implements Action {
  readonly type = REMOVE_ROLE_FROM_USER_SUCCESS;

  constructor(public payload: { userKey: string, role: RoleModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/RemoveRoleFromUserSuccessAction.ts